<template>
  <div id="app" :style="`backgroundColor: ${activitySetting.bodyColor || '#2C1C47'}`">
    <router-view />
    <div class="mask" v-if="!isApp" @click.stop="hanldeRunApp"></div>
  </div>
</template>

<script>
import * as Tool from './tool';
import Api from './api';
import * as Common from './tool/common';
export default {
  data() {
    return {
      activitySetting: {},
      isApp: Tool.webApp.uaIsAutohome(),
      downPageMain: `//a.app.qq.com/o/simple.jsp?pkgname=com.cubic.autohome&ckey=CK1368472478122`,
      downPageCz: `//yczj.m.autohome.com.cn/topic/m/downloadcarcomment/ycdownload.html?t=${new Date().getTime()}&pageSource=guess&pvareaid=${
        Tool.getUrlParam().pvareaid
      }`,
    };
  },
  created() {
    this.getActivitySetting();
  },
  methods: {
    hanldeRunApp() {
      // eslint-disable-next-line
      trackCustomEvent('yc_page_common_click', {
        'bus': '1',
        'page': 'cbz_yjjc_index_dw',
        'refpage': Tool.getCookie('refpage') || '',
        'channel': Tool.getCookie('channel') || '',
        'city': Tool.getCookie('cityId') || 110100,
        'action': 'cbz_yjjc_index_dw_click'
      }, {
        'userId': Tool.getCookie('app_userid') || '',
        'refpage_feed': Tool.getCookie('refpageFeed') || '',
        'pvareaid': Tool.getUrlParam().pvareaid || ''
      });

      if(this.activitySetting.downloadAutohomeLink){
        window.location.href = this.activitySetting.downloadAutohomeLink
        return
      }

      const { shareSource } = Tool.getUrlParam();
      const mainScheme = `autohome://insidebrowser?url=${encodeURIComponent(encodeURIComponent(window.location.href))}`;
      const czScheme = `ahwzsdk://home?scheme=wzsdk%3A%2F%2Fwzarticle%3Furl%3D${encodeURIComponent(encodeURIComponent(window.location.href))}`;
      let params = {};

      // *主软
      if (shareSource === 'autohome') {
        params = {
          AdrDown: this.downPageMain,
          IosDown: this.downPageMain,
          YybPackage: 'com.cubic.autohome',
          YybCkey: 'CK1368472478122',
          URLScheme: mainScheme,
          copyText: '',
        };
      }
      // *车主版 参数空也跳车主版
      if (shareSource === 'wz' || !shareSource)  {
        params = {
          AdrDown: this.downPageCz,
          IosDown: this.downPageCz,
          YybPackage: 'com.autohome.mycar',
          YybCkey: 'CK1496865876152',
          URLScheme: czScheme,
          copyText: '',
        };
      }

      // eslint-disable-next-line
      let call = new AutoCallApp(params);
      call.launch();
    },
    // 获取活动配置
    async getActivitySetting() {
      try {
        let res = await Api.getActivitySetting({
          code: Tool.getUrlParam().code || '',
        });
        if (res.returncode === 0) {
          this.activitySetting = { ...res.result.activitySetting };
        }
      } catch (error) {
        console.log(error, '获取活动配置接口异常信息');
      }
    },
  },
};
</script>

<style lang="scss">
@import './assets/style/index.scss';
#app {
  height: 100%;
  width: 100%;
}
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0);
}
</style>
